module.exports = __webpack_public_path__ + "img/EventWinPage1121.96b3f612.png";